import type { CompanyType, QuickscanAnswers } from '@wtta/scoring'

export interface QuickscanTokenPayload {
  v: 1
  ct: CompanyType
  a: QuickscanAnswers
  iat: number
  exp: number
}

const TOKEN_TTL_DAYS = 30
const MS_PER_DAY = 24 * 60 * 60 * 1000

export function createUnsignedToken(
  companyType: CompanyType,
  answers: QuickscanAnswers,
  now: number = Date.now(),
): string {
  const payload: QuickscanTokenPayload = {
    v: 1,
    ct: companyType,
    a: answers,
    iat: Math.floor(now / 1000),
    exp: Math.floor((now + TOKEN_TTL_DAYS * MS_PER_DAY) / 1000),
  }

  return base64UrlEncode(JSON.stringify(payload))
}

export function decodeUnsignedToken(token: string): QuickscanTokenPayload | null {
  try {
    const decoded = base64UrlDecode(token)
    const parsed = JSON.parse(decoded) as QuickscanTokenPayload
    if (parsed.v !== 1) return null
    if (parsed.exp * 1000 < Date.now()) return null
    return parsed
  } catch {
    return null
  }
}

function base64UrlEncode(input: string): string {
  const utf8 = new TextEncoder().encode(input)
  let binary = ''
  for (const byte of utf8) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function base64UrlDecode(input: string): string {
  const padded = input.replace(/-/g, '+').replace(/_/g, '/').padEnd(
    Math.ceil(input.length / 4) * 4,
    '=',
  )
  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new TextDecoder().decode(bytes)
}
